import { safeStorage } from '@patchbay/ui'

export type ThemePref = 'light' | 'dark' | 'system'

export function getThemePref(): ThemePref {
  const t = safeStorage.getItem('patchbay-theme')
  return t === 'light' || t === 'dark' ? t : 'system'
}

export function applyTheme(pref: ThemePref): void {
  safeStorage.setItem('patchbay-theme', pref)
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches)
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
}
